import * as stacks from "./portfolio/stacks";

export const courses: ICourse[] = [
  // CS50x
  {
    title: {
      english: "Harvard University's Introduction to Computer Science Course",
      portuguese:
        "Curso de Introdução às Ciências da Computação da Universidade de Harvard",
    },
    description: {
      english:
        "Harvard University’s introduction to the intellectual enterprises of computer science and the art of programming.",
      portuguese:
        "Introdução da Universidade de Harvard às empresas intelectuais da ciência da computação e a arte da programação.",
    },
    stack: [
      stacks.StackC,
      stacks.StackJavascript,
      stacks.StackPython,
      stacks.StackFlask,
      stacks.StackSqlite,
      stacks.StackGithubPages,
      stacks.StackHTML,
      stacks.StackCSS,
    ],
    link: "https://www.youtube.com/playlist?list=PLRgQhCLkpfUukDhzjF8XJP_58KjaOowd6",
    image: "http://img.youtube.com/vi/Li85z0EfiUA/maxresdefault.jpg",
    language: "portuguese",
  },
  // JS, HTML, CSS Web Dev
  {
    title: {
      english: "Web Development Projects with JavaScript, HTML, and CSS",
      portuguese: "Projetos de Desenvolvimento Web com JavaScript, HTML e CSS",
    },
    description: {
      english:
        "Learn how to develop web applications with Vanilla JavaScript (no framework), HTML, and CSS.",
      portuguese:
        "Aprenda a desenvolver aplicativos da web com JavaScript Vanilla (sem framework), HTML e CSS.",
    },
    stack: [stacks.StackJavascript, stacks.StackHTML, stacks.StackCSS],
    link: "https://www.youtube.com/playlist?list=PLxytkjDzvsgeITlViNOtlmtyI44dp2arr",
    image: "http://img.youtube.com/vi/1loPW0w2v7w/maxresdefault.jpg",
    language: "portuguese",
  },
  // MERN + TypeScript
  {
    title: {
      english:
        "Full Stack Web Development with TypeScript, React, NodeJS, Express, and MongoDB",
      portuguese:
        "Desenvolvimento Web Full Stack com TypeScript, React, NodeJS, Express e MongoDB",
    },
    description: {
      english:
        "Learn how to develop modern web applications with MERN stack + TypeScript.",
      portuguese:
        "Aprenda a desenvolver aplicativos da web modernos com a pilha MERN + TypeScript.",
    },
    stack: [
      stacks.StackReact,
      stacks.StackNode,
      stacks.StackExpress,
      stacks.StackMongodb,
      stacks.StackTypescript,
      stacks.StackTailwindcss,
    ],
    link: "https://www.youtube.com/playlist?list=PLxytkjDzvsgdhPnQsKdLB12pRIXERgPuW",
    image: "http://img.youtube.com/vi/jdSm-3cFsMg/maxresdefault.jpg",
    language: "portuguese",
  },
];
